enum ErrorMessage {
  NotFound = 'We can‘t find the page you’re looking for',
  Error = 'Something has gone wrong...',
}

export default ErrorMessage;
